module.exports = __webpack_public_path__ + "static/img/14002009.4b73255f.png";